import { useModalStore } from '../..'
import type { FullStore } from '../types'
import type { ModalInput } from './types'

const getStore = () => useModalStore.getState() as FullStore

export const modalActions = {
    addModal: (modal?: ModalInput) => getStore().addModal(modal),
    removeModal: (id: number) => getStore().removeModal(id),
    closeModal: (id: number) => getStore().closeModal(id),
    clearAllModals: () => getStore().clearAllModals(),
    updateModal: (id: number, updates: ModalInput) => getStore().updateModal(id, updates),
}
